const EApplicationContent = `


Application for approval of agreement under section 80-O.

11E. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]



`;

export default EApplicationContent;